import React, { Component } from 'react';
import ReactTable from 'react-table';
import moment from 'moment';
import { Line } from 'react-chartjs-2';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import Datetime from 'react-datetime';
import nanoid from 'nanoid';
import {
	Card,
	CardBody,
	CardTitle,
	Button,
	FormGroup,
	Row,
	Col,
	Input,
	Alert,
	Media
} from 'reactstrap';

import { closeAlert } from '../../../actions/commonsActions';
import {downloadCompaniesCsvStat, fetchCompaniesStats, filteringCompaniesStats} from '../../../actions/statsActions';
import { fetchCompanies } from '../../../actions/companyActions';
import { USER_ROLES } from '../../../helpers/constants';
import Pagination from '../../Pagination/Pagination';
import {getRandomRgb, getColorsObject} from '../../../helpers/getRandomRgb';
import {I18n} from "../../../I18n/components/statistics";

import 'react-datetime/css/react-datetime.css';
import 'react-table/react-table.css';
import './companies-stat.css';
import profilephoto from '../../../assets/images/users/1.jpg';
import spinner from "../../../assets/images/spinner.gif";
import {createCsv} from "../../../helpers/createCsv";

class CompaniesStat extends Component {
	constructor(props) {
		super(props);
		this.state = {
			dateFrom: moment(1, 'DD').format('YYYY-MM-DD'),
			dateTo: moment().format('YYYY-MM-DD'),
			colors: []
		};
	}

	componentDidMount() {
		(async () => {
			await this.props.fetchCompaniesStats({
				dateFrom: this.state.dateFrom,
				dateTo: this.state.dateTo
			});
			const stats = this.props.filteredStats || this.props.stats;
			this.setState({
				colors: stats.map(() => getColorsObject(0.1))
			})
		})();
	}

	onFilterClick = event => {
		const value = event.target.value;
		this.props.filteringCompaniesStats(value);
	};

	dateToTimeChange = moment => {
		this.setState({
			dateTo: moment.format('YYYY-MM-DD')
		})
	};

	dateFromTimeChange = moment => {
		this.setState({
			dateFrom: moment.format('YYYY-MM-DD')
		})
	};

	getFiltered = async () => {
		await this.props.fetchCompaniesStats({
			dateFrom: this.state.dateFrom,
			dateTo: this.state.dateTo
		});
		const stats = this.props.filteredStats || this.props.stats;
		this.setState({
			colors: stats.map(() => getColorsObject(0.1))
		})
	};

	clearFilters = () => {
		this.setState({
			dateFrom: moment(1, 'DD').format('YYYY-MM-DD'),
			dateTo: moment().format('YYYY-MM-DD')
		}, async () => {
			await this.props.fetchCompaniesStats({
				dateFrom: this.state.dateFrom,
				dateTo: this.state.dateTo
			});
			const stats = this.props.filteredStats || this.props.stats;
			this.setState({
				colors: stats.map(() => getColorsObject(0.1))
			})
		})
	};

	downloadCsv = () => {
		const {dateTo, dateFrom} = this.state;
		this.setState({
			isCsvDownload: true
		}, async () => {
			const response = await this.props.downloadCompaniesCsvStat({dateTo, dateFrom});
			if (response) {
				createCsv(response);
			}
			this.setState({
				isCsvDownload: false
			})
		})
	};

	render() {
		const {lang} = this.props;
		return (
			<div className='companies-stats'>
				{/*----------------------- alerts -----------------------------------*/}
				<Alert
					color={`${this.props.alert.alert.status}`}
					isOpen={this.props.alert.isOpen || false}
				>
					{this.props.alert.isOpen ? `${this.props.alert.alert.message}` || "Failed": ''}
				</Alert>
				<Card>
					<CardTitle className="mb-0 p-3 border-bottom bg-light">
						<div>
							<i className="mdi mdi-border-right mr-2"></i>{I18n[lang].companies.title}
						</div>
					</CardTitle>

					<CardBody>
						{
							(() => {
								const {statsLoading} = this.props;
								if (statsLoading) {
									return <div className="loading">Loading...</div>;
								} else {
									let stats = this.props.filteredStats || this.props.stats;
									let labels = [];
                                    let maxDataValue = null;
									let dataSets = stats.reduce((res, company, i) => {
										const { chartPoints } = company;
										if (chartPoints && chartPoints.length) {
											const color = this.state.colors[i];
											const data = chartPoints.map(elem => elem.value);
											const maxValue = Math.max(data);
											maxDataValue = maxValue > maxDataValue ? maxValue : maxDataValue;
											const dataSet = {
												label: company.companyName,
                                                data: data,
                                                //fill: false,
                                                borderWidth: 1,
                                                backgroundColor: color ? color.opacityColor : '',
                                                borderColor: color? color.mainColor : '',
                                                pointBorderColor: color? color.mainColor : '',
                                                pointBackgroundColor: color? color.mainColor : '',
											};
											res.push(dataSet);
										}
										return res;
									},[]);
									if (stats.length && stats[0].chartPoints && stats[0].chartPoints.length) {
										labels = stats[0].chartPoints.reduce((res, chart) => {
											res.push(chart.label);
											return res
										}, [])
									}

									const tableData = stats.map(company => {
										return {
											id: company.id,
											name: company.companyName,
											admin: company,
											stores: company.totalSalesPoints,
											storesActive: company.activeSalesPoints,
											devices: company.totalDevices,
											apps: company.totalApps,
											company: company
										};
									});
									return (
										<div>
											<Row className="stat-graf">
												<Col lg="12">
													<div className="campaign ct-charts">
														<div className="chart-wrapper"
															style={{ width: '100%', margin: '0 auto', height: 350 }}>
															<Line
																data={{
																	datasets: dataSets,
																	labels: labels
																}}
                                                                datasetKeyProvider={() => `${nanoid()}`}
                                                                options={{
																	maintainAspectRatio: false,
																	legend: {
																		display: false,
																		labels: { fontFamily: "Nunito Sans" }
																	},
																	scales: {
																		yAxes: [{
																			stacked: false,
																			gridLines: { display: false },
																			ticks: {
																				fontFamily: "Nunito Sans",
                                                                                beginAtZero:true,
                                                                                min: 0,
                                                                                stepSize: (maxDataValue / 2).toFixed()
																			}
																		}],
																		xAxes: [{
                                                                            stacked: false,
																			gridLines: { display: false },
																			ticks: {
																				fontFamily: "Nunito Sans",
                                                                                stepSize: 1,
                                                                                beginAtZero:true
																			}
																		}]
																	}
																}}
															/>
														</div>
													</div>
												</Col>
											</Row>
											<Row>
												<Col lg="12">
													<FormGroup>
														<Input
															className="company-search-filter"
															type="text"
															name="search"
															id="search"
															onChange={this.onFilterClick}
															placeholder={I18n[lang].companies.placeholder}
														/>
														<Datetime
															className="company-data-filter"
															locale="en-gb"
															timeFormat={false}
															inputProps={{ placeholder: `${I18n[lang].companies.dateFrom}`, readOnly:true }}
															onChange={this.dateFromTimeChange}
															closeOnSelect={true}
															value={this.state.dateFrom ? moment(this.state.dateFrom).format('DD.MM.YYYY'): ''}
														/>
														<Datetime
															className="company-data-filter date-to"
															locale="en-gb"
															timeFormat={false}
															closeOnSelect={true}
															inputProps={{ placeholder: `${I18n[lang].companies.dateTo}`, readOnly:true }}
															onChange={this.dateToTimeChange}
															value={this.state.dateTo ? moment(this.state.dateTo).format('DD.MM.YYYY'): ''}
														/>
														<div className="company-btn__group">
															<Button
																color="primary"
																type="button"
																className="company-btn btn-filter"
																onClick={this.getFiltered}
															>
																{I18n[lang].companies.filter}
															</Button>
															<Button
																color="primary"
																type="button"
																className="company-btn btn-clear"
																onClick={this.clearFilters}
															>
																{I18n[lang].companies.resetFilter}
															</Button>
                                                            <Media
                                                                className={!this.state.isCsvDownload ?
                                                                    'company-btn__spinner visually-hidden' : 'company-btn__spinner'}
                                                                object
                                                                src={spinner}
                                                                alt="Generic placeholder image"
                                                            />
															<Button
																color="secondary"
																type="button"
																className={this.state.isCsvDownload ?
																	'company-btn apk__download invisible' :
																	'company-btn apk__download visible'}
																onClick={this.downloadCsv}
															>
																{I18n[lang].companies.download}
															</Button>
														</div>
													</FormGroup>
												</Col>
											</Row>
											<div className="stat-table">
												<ReactTable
													getProps={(state, rowInfo, column, instance) => {
														return {
															style: {
																border: "none",
																padding: "5px"
															}
														};
													}}
													getTheadProps={(state, rowInfo, column, instance) => {
														return {
															style: {
																boxShadow: "none",
																padding: "10px 0",
																fontWeight: "600"
															}
														};
													}}
													getTheadThProps={(state, rowInfo, column, instance) => {
														return {
															style: {
																borderRight: "none"
															}
														};
													}}
													getTdProps={(state, rowInfo, column, instance) => {
														return {
															style: {
																borderRight: "none",
																textAlign: "center"
															}
														};
													}}
													getTrProps={(state, rowInfo, column, instance) => {
														return {
															onClick: () => {
																const {dateFrom, dateTo} = this.state;
																this.props.changeLocation(`/dashboard/statistics/companies/${rowInfo.row.admin.companyId}?dateFrom=${dateFrom}&dateTo=${dateTo}`);
															},
															style: {
																alignItems: "center"
															}
														}
													}}
													getNoDataProps={(state, rowInfo, column, instance) => {
														return {
															style: {
																top: "100%"
															}
														};
													}}
													columns={[
														{
															Header: "#",
															accessor: "count_id",
															sortable: false,
															filterable: false,
															style: {
																textAlign: "left",
																fontSize: "0.7rem",
																textTransform: "lowercase"
															},
															maxWidth: 40,
															Cell: (row) => {
																return <div>{row.index + 1}</div>;
															}
														},
														{
															Header: `${I18n[lang].companies.traderName}`,
															accessor: "name",
															sortable: false,
															filterable: false,
															minWidth: 200,
															style: {
																textAlign: "left"
															}
														},
														{
															Header: `${I18n[lang].companies.admin}`,
															accessor: "admin",
															sortable: false,
															filterable: false,
															maxWidth: 150,
															style: {
																fontSize: "0.7rem",
																textTransform: "lowercase"
															},
															Cell: row => (
																<div className="stat-table__admin">
																	<img
																		src={row.value.img ? row.value.img : profilephoto}
																		alt="admin"
																		className="rounded-circle"
																		width="30"
																	/>
																	<div className="stat-table__admin-info">
																		<span>{row.value.companyManager}</span>
																		<a href={`mailto:${row.value.companyEmail}`}>{row.value.companyEmail}</a>
																	</div>
																</div>
															)
														},
														{
															Header: `${I18n[lang].companies.tt}`,
															accessor: "stores",
															sortable: false,
															filterable: false,
															maxWidth: 90,
															style: {
																fontSize: "0.7rem",
																textAlign: "center"
															}
														},
														{
															Header: `${I18n[lang].companies.activeTT}`,
															accessor: "storesActive",
															sortable: false,
															filterable: false,
															maxWidth: 110,
															style: {
																fontSize: "0.7rem",
																textAlign: "center"
															},
														},
														{
															Header: `${I18n[lang].companies.devices}`,
															accessor: "devices",
															sortable: false,
															filterable: false,
															maxWidth: 80,
															style: {
																fontSize: "0.7rem",
																textAlign: "center"
															},
														},
														// {
														// 	Header: `${I18n[lang].companies.apps}`,
														// 	accessor: "apps",
														// 	sortable: false,
														// 	filterable: false,
														// 	maxWidth: 110,
														// 	style: {
														// 		fontSize: "0.7rem",
														// 		textAlign: "center"
														// 	},
														// },
													]}
													PaginationComponent={Pagination}
													nextText={">>"}
													previousText={"<<"}
													pageSize={100}
													minRows={0}
													defaultPageSize={-1}
													showPaginationBottom={tableData.length  && tableData.length > 100 ? true : false}
													className="-highlight"
													data={tableData}
													filterable
												/>
											</div>
										</div>
									)
								}
							})()
						}
					</CardBody>
				</Card>
			</div>
		)
	}
};

const mapDispatchToProps = dispatch => {
	return {
		closeAlert: () => dispatch(closeAlert()),
		changeLocation: (url) => dispatch(push(url)),
		fetchCompaniesStats: query => dispatch(fetchCompaniesStats(query)),
		filteringCompaniesStats: word => dispatch(filteringCompaniesStats(word)),
		fetchCompanies: (query) => dispatch(fetchCompanies(query)),
		downloadCompaniesCsvStat: query => dispatch(downloadCompaniesCsvStat(query))
	};
};

const mapStateToProps = state => ({
	alert: state.alert,
	companies: state.companiesReducer.companies,
	authority:  state.currentUser.roles[0].authority || USER_ROLES.GUEST,
	stats: state.companiesStatsReducer.stats,
	filteredStats: state.companiesStatsReducer.filteredStats,
	statsLoading: state.companiesStatsReducer.loading,
	lang: state.languageReducer.lang
});

export default connect(mapStateToProps, mapDispatchToProps)(CompaniesStat)



// WEBPACK FOOTER //
// ./src/components/Statistics/CompaniesStat/CompaniesStat.js